import { render, staticRenderFns } from "./FillLogistics.vue?vue&type=template&id=e9b053de&scoped=true&"
import script from "./FillLogistics.vue?vue&type=script&lang=js&"
export * from "./FillLogistics.vue?vue&type=script&lang=js&"
import style0 from "./FillLogistics.vue?vue&type=style&index=0&id=e9b053de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b053de",
  null
  
)

export default component.exports